import React, { FC, memo } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import ZKanbanHeaderBox from "./ZKanbanHeaderBox";
import ZStageColumn from "./ZStageColumn";
import { DropResult } from "react-beautiful-dnd";
import styles from "./index.module.less";
import { IOpportunityKanbanView } from "./interface";

const ZOpportunityKanbanView: FC<IOpportunityKanbanView> = ({
	pipelineStages,
	kanbanHeight,
	handleDragEnd,
	isStageColumnLoading = true
}) => {
	return (
		<DragDropContext
			onDragEnd={(result: DropResult) => handleDragEnd?.(result)}
		>
			<div
				className={styles.kanbanWrapContainer}
				style={{ height: `calc(100vh - ${kanbanHeight}rem)` }}
			>
				{pipelineStages.map(stage => (
					<div
						key={stage.stageId}
						className={`${styles.kanbanColumnWrap} bg-gray-2`}
					>
						<ZKanbanHeaderBox
							allowAddOpportunity={stage.allowAddOpportunity}
							estimatedValue={stage.estimatedValue}
							count={stage.count}
							index={stage.index}
							addOpportunity={stage.addOpportunity}
							stageName={stage.stageName}
							isWonStage={stage.isWonStage}
							isLostStage={stage.isLostStage}
							stagesLength={stage.stagesLength}
							key={stage.stageId}
						/>
						<ZStageColumn
							index={stage.index}
							count={stage.count}
							stageId={stage.stageId}
							handleFetchMoreClick={stage.handleFetchMoreClick}
							isStageColumnLoading={isStageColumnLoading}
							opportunities={stage.opportunities}
						/>
					</div>
				))}
			</div>
		</DragDropContext>
	);
};

export default memo(ZOpportunityKanbanView);
